
let mainFV=new Swiper("#mainSlider",{spaceBetween:0,effect:"fade",speed:800,autoplay:{delay:5000,disableOnInteraction: false}})
,whatsSlider=new Swiper("#whatsSlider",{slidesPerView:'auto',spaceBetween:0,speed:800,loop:true,autoplay:{delay:5000,disableOnInteraction:false,reverseDirection:true}})
,meritSlider=new Swiper("#meritSlider",{slidesPerView:'auto',spaceBetween:0,speed:800,loop:true,navigation:{nextEl:'#meritSlider .swiper-button-next',prevEl:'#meritSlider .swiper-button-prev'},scrollbar:{el:'#meritSlider .swiper-scrollbar'},autoplay:{delay:5000,disableOnInteraction:false}})
,columnSlider=new Swiper("#columnSlider",{slidesPerView:'auto',spaceBetween:0,speed:800,loop:true,navigation:{nextEl:'#columnSlider .swiper-button-next',prevEl:'#columnSlider .swiper-button-prev'},scrollbar:{el:'#columnSlider .swiper-scrollbar'},autoplay:{delay:5000,disableOnInteraction:false}});

window.addEventListener('DOMContentLoaded',contentLoadedTopSet,{passive:true});


function contentLoadedTopSet(){
	setTimeout(function(){scrollLoadTopSet();},600);
}
function scrollLoadTopSet(){
	let floatOptions={root:null,rootMargin:'-30% 0px',threshold:0},
		$mSlider=document.getElementById('mainFV'),
		$floatBtn=document.getElementById('floatBtn'),
		galleryOptions={root:null,rootMargin:'-40% 0px',threshold:0},
		$gallery=[].slice.call(document.querySelectorAll('figure[id*="Gallery"],#reason .reasonBox .fg01'));

	if("IntersectionObserver" in window){
		let floatObserver=new IntersectionObserver(function(entries,observer){
			entries.forEach(function(entry){
				if(entry.isIntersecting){
					$floatBtn.classList.remove('show');
				}else{
					$floatBtn.classList.add('show');
				}
			});
		},floatOptions);
		floatObserver.observe($mSlider);

		let galleryObserver=new IntersectionObserver(function(entries,observer){
			entries.forEach(function(entry){
				if(entry.isIntersecting){
					entry.target.classList.add('show');
				}
			});
		},galleryOptions);
		$gallery.forEach(function(gBox){galleryObserver.observe(gBox);});
	}
}